/* eslint-disable */
const linkablePlansTemplate = `
<div class="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 account-selection ">
    <header class="contained-form-header margin-top-default">
        <h1>
            {{ 'linkablePlans.header' | translate }}
        </h1>
        <p> {{ 'linkablePlans.intro' | translate }} </p>
    </header>
    <div id="statementsDocs-spinner" class="loaderBackground just-element"
        ng-if="LinkablePlansSelectionController.loading">
        <div class="loader"></div>
    </div>
    <form class="with-padding with-top-margin margin-bottom-200" role="form" name="primaryPlanSelectionForm" novalidate>
        <div class="inner-container with-padding with-shadow clearfix">
            <div ng-if="currentUserPlans">
                <div class="flex-heading ng-scope">
                    <label class="control-label" ng-if="currentUserPlans.length >1">{{ 'linkablePlans.thesePlans' |
                        translate }}</label>
                    <label class="control-label" ng-if="currentUserPlans.length == 1">{{ 'linkablePlans.thisPlan' |
                        translate }}</label>
                    <button 
                        class="btn btn-link btn-no-style linkable-plans-tooltip" 
                        style="font-weight: 600"
                        tooltip-placement="right"
                        tooltip-trigger="focus"
                        uib-tooltip-html="'<ul><li>{{ \'linkablePlans.t1\' | translate }}</li><br><li>{{ \'linkablePlans.t2\' | translate }}</li></ul>'"
                    >{{'linkablePlans.learnMore' | translate}}</button>
                </div><!-- end ngIf: !ctrl.uploadInProgress() -->
                <div class="well">
                    <div class="form-group checkbox ng-scope">
                        <label style="margin-left: -20px;">
                            <span data-ng-repeat="currentPlan in currentUserPlans"
                                style="font-size: 16px; white-space:normal">
                                {{currentPlan.planName}}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
            <div ng-if="plansMapWithIndIdDbName">
                <label class="control-label">{{ 'linkablePlans.selectOtherPlans' | translate }}</label>
                <div class="well" style="font-size:16px; background-color: rgba(0, 119, 204, 0.05); border: none">
                    <span class="em-info-icon" style="margin-right: 10px; color: #0077CC; font-weight: bold;"></span>
                    {{ 'linkablePlans.lockInfo1' | translate }}
                    <img ng-src="{{styleEnv}}customizations/Default/images/padlock.svg">
                    {{ 'linkablePlans.lockInfo2' | translate }}
                </div>
                <div class="well" data-ng-repeat="(key, value) in plansMapWithIndIdDbName">
                    <div class="form-group checkbox ng-scope"
                        style="white-space:normal;font-size:16px; margin-top=-5px">
                        <label>
                            <span data-ng-repeat="planValue in value "
                                style="white-space:normal;font-size:16px; margin-top=-5px">
                                <input type="checkbox" ng-model="planValue.checked" ng-value="key"
                                    ng-checked="planValue.checked"
                                    ng-click="LinkablePlansSelectionController.togglePlanSelection(key)"
                                    data-ng-if="$index===0" id="oneid-checkbox" /> {{planValue.planName}}

                            </span>
                        </label>
                        <img ng-src="{{styleEnv}}customizations/Default/images/padlock.svg" class="pull-right oneid-lock" 
                            data-ng-show="LinkablePlansSelectionController.checkIfLockNeeded(key)">
                    </div>
                </div>
            </div>
            <div class="row cta investment-button-row">
                <button id="submitButton" type="submit" class="btn btn-primary pull-right oneid-button-large"
                    ng-disabled="!(LinkablePlansSelectionController.checkForEnabling())"
                    ng-click="LinkablePlansSelectionController.continueClick()">
                    {{ 'choosePrimaryPlan.continuebutton' | translate }}
                </button>
            </div>
        </div>
    </form>
</div>
`;
export default linkablePlansTemplate;
